export default __webpack_public_path__ + "static/media/modus_operandi.afaffd6b.png";